module.exports = __webpack_public_path__ + "front/img/logo_2.ce6bcbec.png";